<script lang="ts" generics="ITEM">
    import type {SearchParams, ViewableSearch} from 'src/typings';
    import type {SearchManager} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';
    import {exists} from 'shared/utils/custom-utils';
    import KpSearchSorting from '../kp-search-sorting/KpSearchSorting.svelte';
    import KpSearchPageSize from '../kp-search-page-size/KpSearchPageSize.svelte';
    import KpAvailableIntentsContainer from '../kp-available-intents/KpAvailableIntentsContainer.svelte';
    import KpHorizontalSeparator from 'shared/ui-widgets/separator/KpHorizontalSeparator.svelte';
    import KpPageableSearchResults from '../kp-search-results/KpPageableSearchResults.svelte';
    import KpResolvableSearchResultsDisplayer from '../kp-resolvable-search-results-displayer/KpResolvableSearchResultsDisplayer.svelte';

    export let searchManager: SearchManager<ITEM>;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();

    $: sortingShowing = exists($lastSearch) && $lastSearch.features && $lastSearch.features.includes('sorting') && $lastSearch.availableSortings.length > 1;
    $: pageSizeShowing = exists($lastSearch) && $lastSearch.features && $lastSearch.features.includes('pageSizeChanging');
</script>

<div class="search-page-size-and-sorting" class:hidden={!sortingShowing && !pageSizeShowing}>
    <KpSearchSorting {searchManager}/>
    <KpSearchPageSize {searchManager}/>
</div>

{#if exists($lastSearch)}
    <KpHorizontalSeparator marginVertical="24px"/>
{/if}

<KpPageableSearchResults pagination={searchManager.getPagination()}
                         showPageButtons={exists($lastSearch) && exists($lastSearch.features) && $lastSearch.features.includes('randomPageAccessing')}
                         loadingSize="md"
                         let:paginationData>

    <KpResolvableSearchResultsDisplayer {searchManager} {paginationData}/>
</KpPageableSearchResults>

<KpAvailableIntentsContainer {searchManager}/>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.media-queries.less";

    .search-page-size-and-sorting {
        margin-top: @spacing-l;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;

        @media (max-width: @screen-xs-max) {
            flex-direction: column;
            gap: @spacing-s;
        }
    }
</style>